/* eslint-disable max-len */
import React from 'react';

export default function Pin() {
	return (
		<svg
			className="svg pin"
			width="16"
			height="21"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g fill="#555">
				<path d="M7.753 9.538a1.908 1.908 0 110-3.815 1.908 1.908 0 010 3.815z" />
				<path d="M9.105 20.493a1.333 1.333 0 01-2.068 0C2.436 14.809.122 10.686.122 7.869.122 3.523 3.681 0 8.071 0s7.948 3.523 7.948 7.87c0 2.816-2.313 6.94-6.914 12.623zM13.37 7.869c0-2.897-2.373-5.246-5.3-5.246-2.926 0-5.298 2.349-5.298 5.246 0 1.84 1.76 5.133 5.299 9.682C11.61 13 13.37 9.709 13.37 7.869z" />
			</g>
		</svg>
	);
}
